module.exports = __webpack_public_path__ + "static/img/18.92bf789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18.png
// module id = 1pOq
// module chunks = 1